import Vue from 'vue';
import all from './all';
import store from './../../store';

const success = (resolve, id) => {
  store.dispatch('destroyBusinessHour', id);
  all();
  resolve();
};

const failed = reject => reject();

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/business_hours/${id}`)
    .then(() => {
      success(resolve, id);
    })
    .catch(() => {
      failed(reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/businessHour/destroy.js